import React from 'react';

const Card = ({
  children,
  title,
  subtitle,
  headerAction,
  padding = true,
  hover = false,
  className = '',
}) => {
  const baseClasses = 'bg-[#131820]/95 rounded-2xl border border-white/10 shadow-xl backdrop-blur';
  const hoverClasses = hover
    ? 'transition-all duration-200 hover:shadow-2xl hover:border-emerald-400/30 hover:bg-[#131820]'
    : '';
  const paddingClass = padding ? 'p-6' : '';

  return (
    <div className={`${baseClasses} ${hoverClasses} ${className}`}>
      {(title || headerAction) && (
        <div
          className={`flex items-center justify-between ${
            padding ? 'pb-4 mb-4' : 'p-6 pb-4'
          } border-b border-white/10`}
        >
          <div>
            {title && <h3 className="text-lg font-semibold text-white">{title}</h3>}
            {subtitle && <p className="mt-0.5 text-sm text-[#d8d2c5]">{subtitle}</p>}
          </div>
          {headerAction && <div>{headerAction}</div>}
        </div>
      )}
      <div className={paddingClass}>{children}</div>
    </div>
  );
};

export default Card;
